"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var selectModule = require("./Select.module.scss");
var react_1 = __importStar(require("react"));
var Menu_1 = require("../../Menu/MenuSuspenso/Menu");
var Tooltip_1 = require("../../Tooltip/Tooltip");
var GradacaoNeutros_1 = __importDefault(require("../../Cores/GradacaoNeutros "));
var MensagensDoSistema_1 = __importDefault(require("../../Cores/MensagensDoSistema"));
var Icone_1 = require("../../Icone/Icone");
var Cores_1 = require("../../Cores/Cores");
var Label_1 = require("../../Label/Label");
var HelperText_1 = require("../../HelperText/HelperText");
var Botao_1 = require("../../Botao/Botao");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var Select = function (_a) {
    var id = _a.id, name = _a.name, valorInicial = _a.valorInicial, _b = _a.titulo, titulo = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "Selecione uma opção" : _c, conteudoDeAjuda = _a.conteudoDeAjuda, _d = _a.selecaoMultipla, selecaoMultipla = _d === void 0 ? false : _d, _e = _a.permitirPesquisa, permitirPesquisa = _e === void 0 ? false : _e, _f = _a.variante, variante = _f === void 0 ? "regular" : _f, _g = _a.tamanho, tamanho = _g === void 0 ? "small" : _g, _h = _a.desabilitado, desabilitado = _h === void 0 ? false : _h, menuProps = _a.menuProps, tooltip = _a.tooltip, campoObrigatorio = _a.campoObrigatorio, itensSelecionadosProp = _a.itensSelecionados, opcoesMenu = _a.opcoesMenu, botaoDeLimpar = _a.botaoDeLimpar, _j = _a.valorObrigatorio, valorObrigatorio = _j === void 0 ? false : _j, style = _a.style, label = _a.label, onChange = _a.onChange, regraTexto = _a.regraTexto;
    var _k = (0, react_1.useState)(itensSelecionadosProp || (Array.isArray(valorInicial) ? valorInicial : valorInicial ? [valorInicial] : [])), itemSelecionado = _k[0], setItemSelecionado = _k[1];
    var _l = (0, react_1.useState)(''), valor = _l[0], setValor = _l[1];
    var _m = (0, react_1.useState)(false), openSelectMenu = _m[0], setOpenSelectMenu = _m[1];
    var _o = (0, react_1.useState)([]), opcoesDisponiveisMenu = _o[0], setOpcoesDisponiveisMenu = _o[1];
    var _p = (0, react_1.useState)(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400), cor = _p[0], setCor = _p[1];
    var selectStyle = selectModule[variante] || "";
    var selectSize = selectModule[tamanho] || "";
    var disabledStyle = desabilitado ? selectModule["disabled"] : "";
    var selectRef = (0, react_1.useRef)(null);
    var gapStyle = titulo || conteudoDeAjuda ? { gap: '12px' } : {};
    var handleSelect = function (itensSelecionados) {
        setItemSelecionado(itensSelecionados);
        selecaoMultipla ? setOpenSelectMenu(true) : setOpenSelectMenu(false);
        onChange && onChange(selecaoMultipla ? itensSelecionados : itensSelecionados !== null ? itensSelecionados[0] : null);
    };
    var toggleMenu = function () {
        !desabilitado && setOpenSelectMenu(function (current) { return !current; });
    };
    var handleClear = function () {
        setItemSelecionado(null);
        setOpenSelectMenu(false);
        onChange && onChange(null);
    };
    var verificarValor = function (valor) {
        if (valor !== null) {
            if (valor.length === 1) {
                return globalMu_1.default.isDeepEqual(valor[0], {}) ? false : globalMu_1.default.isNotNullOrEmptyOrUndefined(valor[0]) ? true : false;
            }
            else {
                return globalMu_1.default.isDeepEqual(valor, []) ? false : globalMu_1.default.isNotNullOrEmptyOrUndefined(valor) ? true : false;
            }
        }
        else {
            return false;
        }
    };
    var getValorString = function (valor) {
        if (valor !== null) {
            if (valor.length === 1) {
                return regraTexto(valor[0]);
            }
            else {
                return valor.map(function (item) { return regraTexto(item); }).join(", ");
            }
        }
        else {
            return "";
        }
    };
    var dicas = react_1.default.createElement("div", { className: "".concat(selectModule.tooltip, " ").concat(selectSize) },
        react_1.default.createElement(Tooltip_1.Tooltip, __assign({}, tooltip, { tituloTooltip: "", descricaoTooltip: "Lorem Ipsum" }),
            react_1.default.createElement(Icone_1.Icone, { nome: "info", cor: cor })));
    var ValorSelecionado = react_1.default.createElement("input", { className: selectModule.input, title: valor, value: valor, placeholder: placeholder, readOnly: true, disabled: desabilitado, autoComplete: "off", name: name, id: id, onClick: function () { return toggleMenu(); } });
    var BotaoExpandaMais = react_1.default.createElement("div", { onClick: function () { return toggleMenu(); }, className: "\n                ".concat(selectModule.selectIcon, "\n                ").concat(selectStyle, "\n                ").concat(disabledStyle, "\n            ") },
        react_1.default.createElement(Icone_1.Icone, { nome: openSelectMenu ? "expand_less" : "expand_more", desabilitado: desabilitado, cor: GradacaoNeutros_1.default.CinzaFillMU600, corOnHover: Cores_1.Cores.GradacaoPrimaria.AzulMU500 }));
    var BotaoLimpar = (react_1.default.createElement(Botao_1.Botao, { onClick: function () { return handleClear(); }, estilo: "ghost", exibirBotaoArrendondado: true, tamanho: "xsmall", tipo: "tipoIconRound" },
        react_1.default.createElement(Icone_1.Icone, { nome: "close", altura: "16px", desabilitado: desabilitado, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU })));
    var SelectInput = (react_1.default.createElement("div", { ref: selectRef, className: "\n                ".concat(selectModule.select, "\n                ").concat(disabledStyle, "\n                ").concat(selectStyle, "\n                ").concat(selectSize, "\n            ") },
        tooltip && dicas,
        ValorSelecionado,
        (botaoDeLimpar &&
            verificarValor(itemSelecionado) &&
            !desabilitado) && BotaoLimpar,
        BotaoExpandaMais,
        openSelectMenu && (react_1.default.createElement("div", { className: "\n                    ".concat(selectModule.menu, "\n                    ").concat(selectModule[(menuProps === null || menuProps === void 0 ? void 0 : menuProps.posicaoDoMenu) || "below"], "\n                    ").concat(selectStyle, "\n                    ").concat((menuProps === null || menuProps === void 0 ? void 0 : menuProps.temMenuTip) ? selectModule.tip : "", "\n                ") },
            react_1.default.createElement(Menu_1.Menu, __assign({ opcoesMenu: opcoesDisponiveisMenu, itensSelecionados: itemSelecionado, permitirMultiplaSelecao: selecaoMultipla, onSelect: handleSelect, regraTexto: regraTexto, tipoDoMenu: selecaoMultipla ? "options" : "actions", valorObrigatorio: valorObrigatorio }, menuProps, { permitirPesquisa: permitirPesquisa !== null && permitirPesquisa !== void 0 ? permitirPesquisa : false }))))));
    var TextoDeAjuda = (react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || "", estado: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.estado) || variante, desabilitado: desabilitado, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone }));
    var Titulo = (react_1.default.createElement(Label_1.Label, { texto: titulo, desabilitado: desabilitado, estado: variante, negrito: 700, htmlFor: id, obrigatorio: campoObrigatorio }));
    (0, react_1.useEffect)(function () {
        setValor(getValorString(itemSelecionado));
    }, [itemSelecionado]);
    (0, react_1.useEffect)(function () {
        setValor(getValorString(itemSelecionado));
    }, []);
    (0, react_1.useEffect)(function () {
        setItemSelecionado(itensSelecionadosProp || (Array.isArray(valorInicial) ? valorInicial : valorInicial ? [valorInicial] : []));
    }, [valorInicial, itensSelecionadosProp]);
    (0, react_1.useEffect)(function () {
        return desabilitado ?
            setCor(GradacaoNeutros_1.default.CinzaFillMU400) :
            setCor(variante === "error" ? MensagensDoSistema_1.default.VermelhoMU : GradacaoNeutros_1.default.CinzaFillMU600);
    }, [variante, desabilitado]);
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setOpenSelectMenu(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", function (event) {
                return handleClickOutside(event);
            });
        };
    }, [selectRef]);
    (0, react_1.useEffect)(function () {
        setOpcoesDisponiveisMenu(opcoesMenu);
    }, [opcoesMenu]);
    return (react_1.default.createElement("div", { className: "".concat(selectModule.selectComponent), style: __assign(__assign({}, style), gapStyle) },
        label ? Titulo : null,
        SelectInput,
        TextoDeAjuda));
};
exports.Select = Select;
